import * as Constants from '../constants/salesforce-import';

export const createSalesforceImport = ($http, ENV, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_SALESFORCE_IMPORT_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/reporting-database/salesforce-files/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_SALESFORCE_IMPORT_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_SALESFORCE_IMPORT_FAILED, payload: error });
        reject(error);
      });
  });

export const updateSalesforceImport = ($http, ENV, salesforceImportId, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_SALESFORCE_IMPORT_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/reporting-database/salesforce-files/${salesforceImportId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_SALESFORCE_IMPORT_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_SALESFORCE_IMPORT_FAILED, payload: error });
        reject(error);
      });
  });

export const getSalesforceImport = ($http, ENV, salesforceImportId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_SALESFORCE_IMPORT_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/reporting-database/salesforce-files/${salesforceImportId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_SALESFORCE_IMPORT_SUCCESS,
          payload: res.data['salesforce-file'],
        });
        resolve(res.data['salesforce-file']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_SALESFORCE_IMPORT_FAILED, payload: error });
        reject(error);
      });
  });

export const deleteSalesforceImport = ($http, ENV, salesforceImportId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.DELETE_SALESFORCE_IMPORT_REQUEST });

    $http({
      method: 'DELETE',
      url: ENV.apiEndpoint + `/2.0/reporting-database/salesforce-files/${salesforceImportId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.DELETE_SALESFORCE_IMPORT_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.DELETE_SALESFORCE_IMPORT_FAILED, payload: error });
        reject(error);
      });
  });

export const setSalesforceImport = (data) => (dispatch) =>
  dispatch({ type: Constants.SET_SALESFORCE_IMPORT, payload: data });
